import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  mergeAlertsToCaseFail,
  mergeAlertsToCaseSuccess,
  MERGE_ALERTS_TO_CASE
} from '../../redux/actions/cm/mergeAlertsToCase';
import { mergeAlertsToCase } from '../../services/cm/alerts';

function* mergeAlertsToCaseWorker({ alertIds, caseId }) {
  try {
    const { assignedDepartmentId } = yield call(mergeAlertsToCase, {
      alertIds,
      caseId
    });
    yield put(mergeAlertsToCaseSuccess({ assignedDepartmentId }));
  } catch (error) {
    yield put(mergeAlertsToCaseFail(error));
  }
}

export function* watchMergeAlertsToCase() {
  yield takeEvery(
    MERGE_ALERTS_TO_CASE,
    function* ({ payload: { alertIds, caseId } }) {
      yield fork(mergeAlertsToCaseWorker, { alertIds, caseId });
    }
  );
}
